import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { PublicLayout, Section } from "@/components/PublicLayout";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export function PaymentSuccess() {
  const nav = useNavigate();
  const [status, setStatus] = useState("checking");
  const [appId, setAppId] = useState(null);
  useEffect(() => {
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        setAppId(data.application_id);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (tries >= 8) { setStatus("pending"); return; }
      } catch { if (tries >= 8) { setStatus("error"); return; } }
      setTimeout(poll, 2000);
    };
    poll();
  }, []);
  return (
    <PublicLayout>
      <Section className="py-24 max-w-xl text-center">
        {status === "checking" && <><Loader2 className="h-10 w-10 text-heraldic animate-spin mx-auto" /><p className="mt-4 text-ink/60">Confirming your payment…</p></>}
        {status === "paid" && (
          <>
            <CheckCircle2 className="h-12 w-12 text-heraldic mx-auto" />
            <h1 className="mt-5 font-serif text-4xl text-ink">Application fee received</h1>
            <p className="mt-3 text-ink/60">You may now begin the final stage — the cognitive assessment.</p>
            <button data-testid="goto-assessment" onClick={() => nav(`/assessment/${appId}`)} className="mt-8 bg-heraldic text-white px-8 py-3.5 rounded-sm hover:bg-heraldic-700 transition-colors">Begin cognitive assessment</button>
          </>
        )}
        {status === "pending" && <><Loader2 className="h-10 w-10 text-heraldic mx-auto" /><p className="mt-4 text-ink/60">Payment is processing. You can begin the assessment shortly.</p></>}
        {status === "error" && <><XCircle className="h-12 w-12 text-destructive mx-auto" /><p className="mt-4 text-ink/60">We couldn't confirm your payment. Please contact admissions@simo.university.</p></>}
      </Section>
    </PublicLayout>
  );
}

export function PaymentCancel() {
  const nav = useNavigate();
  return (
    <PublicLayout>
      <Section className="py-24 max-w-xl text-center">
        <XCircle className="h-12 w-12 text-ink/40 mx-auto" />
        <h1 className="mt-5 font-serif text-4xl text-ink">Payment cancelled</h1>
        <p className="mt-3 text-ink/60">Your application is saved. You can complete the fee whenever you're ready.</p>
        <button onClick={() => nav("/apply")} className="mt-8 bg-ink text-paper px-8 py-3.5 rounded-sm hover:bg-heraldic transition-colors">Return to application</button>
      </Section>
    </PublicLayout>
  );
}
